import React from 'react'
import AccountLoginPage from '../../components/Merchant/MerchantOnboarding/AccountLogin';

const AccountLogin = () => {
  return (
    <AccountLoginPage />
  )
}

export default AccountLogin;